import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SheEarnsIncome = () => {
    const authState = useSelector((state) => state.authReducer || {});
    const isLoggedIn = authState?.isLoggedIn || false;
    const userName = authState?.user?.name || "User";

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
    };

  const [activeTab, setActiveTab] = useState('overview');

  const incomeTabs = [
    {
      key: "my-digital-referral-income",
      label: "My Digital Referral Income",
      emoji: "🔗💰",
      desc: "Earn when your network grows through your shared links. Every referral is a step toward greater rewards.",
      link: "/bookshelf"
    },
    {
      key: "my-product-referral-income",
      label: "My Product Referral Income",
      emoji: "📦💰",
      desc: "Recommend products you trust — and earn each time someone buys through you.",
      link: "/orderflow-myproducts"
    },
    {
      key: "my-reseller-income",
      label: "My Reseller Income",
      emoji: "🔄💰",
      desc: "Build your own digital shop, grow your offers, and watch recurring income flow in.",
      link: "/orderflow-resellerincome"
    },
    {
      key: "my-introducer-bonus-income",
      label: "My Introducer Bonus Income",
      emoji: "🎁💰",
      desc: "Inspire others to join and enjoy special one-time bonuses for each new connection you bring onboard.",
      link: "/sheearns-introducerincome"
    },
    {
      key: "my-ad-watch-income",
      label: "My Ad Watch Income",
      emoji: "👁️💰",
      desc: "Get rewarded for your attention — watch, engage, and earn. Simple and powerful.",
      link: "/sheearns-adwatchincome"
    },
    {
      key: "my-content-income",
      label: "My Content Income",
      emoji: "📝💰",
      desc: "Share your creativity — articles, videos, or tips — and earn from the value you create.",
      link: "/sheearns-mycontentwatchincome"
    },
    {
      key: "claim-request-for-self",
      label: "Claim Request for Self",
      emoji: "💳💰",
      desc: "Claim Your Digital Earnings and get into your bank account transferred upon verification abd Think5Whys policies..",
      link: "/sheearns-claim"
    },
    {
      key: "my-reward-points",
      label: "My Reward Points",
      emoji: "⭐💰",
      desc: "Collect points for actions, unlock perks, and convert your effort into tangible rewards.",
      link: "/sheearns-rewardpointsincome"
    }
  ];

  const tabs = [
    { key: 'overview', label: 'Overview', emoji: '🌟' },
    ...incomeTabs
  ];

  const renderTabContent = (tabKey) => {
    if (tabKey === 'overview') {
      return (
        <>
          {/* Header */}
          <h2 className="mt-2 text-xl lg:text-2xl font-extrabold bg-gradient-to-r from-pink-500 to-pink-600 bg-clip-text text-transparent mb-3">
            🌟 My Digital Income — Earn. Share. Grow.
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto text-base lg:text-lg mb-2">
            Welcome to your <span className="font-semibold text-pink-400">Digital Income Hub</span> — where your actions, ideas, and influence turn into real rewards! 
            Every click, share, and connection you make here adds up to something meaningful.
          </p>

          {/* Income Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
            {incomeTabs.map((item) => (
              <div
                key={item.key}
                onClick={() => setActiveTab(item.key)}
                className="bg-gray-800 rounded-2xl p-5 shadow-md hover:shadow-pink-500/25 hover:shadow-xl transition-transform hover:-translate-y-1 flex gap-3 text-left cursor-pointer"
              >
                <div className="text-3xl flex-shrink-0 bg-gradient-to-b from-pink-900 to-gray-700 rounded-xl w-12 h-12 flex items-center justify-center shadow-inner">
                  {item.emoji}
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-white text-base">{item.label}</h3>
                  <p className="text-gray-400 text-sm mt-1 leading-snug">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="mt-4">
            <p className="text-gray-300 font-medium mb-2 text-base md:text-lg">
              This is more than just income — it’s your path to{" "}
              <span className="font-semibold text-pink-400">financial freedom and digital empowerment</span>.
              Start today. Be consistent. Watch your digital influence turn into real growth! 🚀
            </p>
            <a
              href="/sheearns-myincome"
              className="inline-block bg-gradient-to-r from-pink-500 to-pink-600 text-white font-semibold py-2.5 px-6 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition"
            >
              Explore My Income
            </a>
          </div>
        </>
      );
    }

    const selectedTab = incomeTabs.find(tab => tab.key === tabKey);
    if (!selectedTab) return null;

    return (
      <div className="text-center mt-2">
        <div className="text-xl lg:text-2xl mb-2">{selectedTab.emoji}</div>
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">{selectedTab.label}</h3>
        <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto mb-3 leading-relaxed">
          {selectedTab.desc}
        </p>
        {selectedTab.link ? (
          <a
            href={selectedTab.link}
            className="inline-block bg-gradient-to-r from-pink-500 to-pink-600 text-white font-semibold py-3 px-8 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition"
          >
            Go to {selectedTab.label}
          </a>
        ) : (
          <p className="text-gray-500 font-medium bg-gray-800 rounded-xl py-3 px-4 inline-block">
            Coming Soon 🚀
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="bg-black min-h-screen text-white">
      <div className="flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
                    {/* Header */}
                    <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
                      <div className="flex flex-col">
                        <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns</div>
                        <div className="text-[10px] lg:text-lg text-yellow-200">
                          SAKSHAM Shakti Profile
                        </div>
                      </div>
              
                      {/* Desktop user controls */}
                      <div className="hidden md:flex items-center gap-3">
                        {isLoggedIn ? (
                          <>
                            <div className="text-xs text-left text-pink-300">{userName}</div>
                            <button
                              onClick={handleLogout}
                              className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                              title="Logout"
                            >
                              ⏻
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => navigate("/login")}
                              className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                            >
                              Login
                            </button>
                            <button
                              onClick={() => navigate("/signup")}
                              className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                            >
                              Register
                            </button>
                          </>
                        )}
                      </div>
              
                      {/* Mobile hamburger */}
                      <button
                        onClick={() => setIsMobileMenuOpen((s) => !s)}
                        className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
                        aria-label="Toggle menu"
                      >
                        {isMobileMenuOpen ? "×" : "☰"}
                      </button>
                    </header>
              
                    {/* Mobile menu content */}
                    {isMobileMenuOpen && (
                      <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
                        {isLoggedIn ? (
                          <div className="flex flex-row items-center justify-center gap-3">
                            <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                              Welcome, {userName}
                            </span>
                            <button
                              onClick={handleLogout}
                              className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                              title="Logout"
                            >
                              ⏻
                            </button>
                          </div>
                        ) : (
                          <div className="flex flex-row items-center justify-center gap-6">
                            <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                              Login
                            </Link>
                            <span className="text-pink-500">|</span>
                            <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                              Register
                            </Link>
                          </div>
                        )}
                      </div>
                    )}
        </div>
      <section className="bg-gradient-to-b from-gray-900 to-black py-4 px-4 mb-2">
        <div className="max-w-6xl mx-auto">
          {/* Tabs Navigation */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mt-1 place-items-center border border-pink-400 py-2 px-4">
            {tabs.map((tab) => (
                <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex flex-col items-center gap-1 px-3 py-2 rounded-lg transition-colors ${
                    activeTab === tab.key
                    ? 'bg-pink-600 text-white shadow-lg'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                }`}
                >
                <span className="text-2xl">{tab.emoji}</span>
                <span className="font-medium text-xs text-center">{tab.label}</span>
                </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="text-center">
            {renderTabContent(activeTab)}
          </div>
        </div>
      </section>
      {/* Footer */}
            <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
              <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                <div className="text-xs lg:text-sm">
                  © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
                </div>
                <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                  <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                  <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                  <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                  <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default SheEarnsIncome;